var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":"Activar Plan de Cuentas","value":true},on:{"close-modal":_vm.closeModal}},[_c('acc-plan-active-form',{attrs:{"subsidiary-id":_vm.params.subsidiaryId,"year-accountant-id":_vm.params.yearAccountantId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54e97485","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/accounting-plans/page-accounting-plan-active.vue
// module id = 1332
// module chunks = 44